import React, {useState} from 'react';
import {callWithCatch, pp, tourneyUrl} from "../utils";
import {observer} from "mobx-react";
import {LoaderDrawer, NiceModalForm} from "./Modals";
import NiceModal from "@ebay/nice-modal-react";
import FakeTable from "./FakeTable";
import {Alert, Button, Form, Input, Radio, Switch} from "antd";
import {TagOutlined, TagsOutlined, TeamOutlined, UserOutlined} from "@ant-design/icons";
import {TextCopy} from "./LinkCopy";

let ActiveSwitch = ({c, refresh}) => {
  const [loading, setLoading] = useState(false);

  let save = () => {
    callWithCatch({
      setLoading,
      url: tourneyUrl('/coupons') + "/" + c.id,
      method: 'put',
      params: { active: !c.active },
      onSuccess: () => {
        c.active = !c.active;
        // refresh()
      }
    })
  }

  return <Switch checked={c.active} loading={loading} onChange={save} />
}

let Add = NiceModal.create(observer(({addCoupon}) => {
  let onSave = async (params) => {
    await callWithCatch({
      url: tourneyUrl("/coupons"),
      method: 'post',
      params,
      onSuccess: data => addCoupon(data.coupon)
    });

    return true;
  }

  return <NiceModalForm width={300} okText="Add" onSave={onSave} title="Add Coupon" initialValues={{kind: 'multi'}}>
    <Form.Item name="kind" label="Kind" rules={[{required: true}]}>
      <Radio.Group>
        <Radio value="multi">Multi Use</Radio>
        <Radio value="single">Single Use</Radio>
      </Radio.Group>
    </Form.Item>
    <Form.Item name="code" label="Code" extra="uppercase and numbers only" rules={[{required: true, pattern: /^[A-Z0-9]+$/, message: "e.g. XZ6HC"}]}>
      <Input style={{width: "100%"}} autoFocus />
    </Form.Item>
    <Form.Item name="discount" label="Discount" extra="amount in dollars e.g. 50" rules={[{required: true, pattern: /^[1-9]\d*$/, message: "enter a positive number"}]}>
      <Input style={{width: "100%"}} />
    </Form.Item>
  </NiceModalForm>
}));

export default NiceModal.create(observer(({}) => {
  const [data, setData] = useState(false);

  let loadParams = {
    url: tourneyUrl('/coupons'),
    method: 'get',
    onSuccess: data => setData(data),
  }

  let refresh = () => setData(_.clone(data));
  let addCoupon = c => {
    data.coupons.push(c);
    refresh();
  }

  let render = c => {
    return [c.single ? "1" : "∞", c.code, c.effect_text, c.user || <ActiveSwitch c={c} refresh={refresh}/>];
  }

  return <LoaderDrawer params={loadParams} width={500}>
    {data && <div className="space-y-8">
      <Button type="primary" onClick={() => NiceModal.show(Add, {addCoupon})}>Add Coupon</Button>
      <FakeTable small objs={data.coupons} headers={['', 'Code', 'Discount', 'Active?']} tds={render} />
      {/*<h2 className="text-lg">Single Use</h2>*/}
      {/*<FakeTable small objs={data.single} headers={['Code', 'Discount']} tds={render} />*/}
    </div>}
  </LoaderDrawer>
}));
